import Vue from 'vue';
import LocaleDateTimeInput from '~/components/shared/LocaleDateTimeInput.vue';

export default () => {
	Vue.component('locale-date-time-input', LocaleDateTimeInput);
};